<!-- MARK: Actions -->
<app-section sectionTitle="Actions">
  <button class="form-item-button" mat-mini-fab (click)="updateStats()" [disabled]="this.loadingBarService.getDisableSlowAPIButtons()" color="primary" matTooltip="Refresh Stats" aria-label="Refresh Flips">
    <mat-icon>refresh</mat-icon>
  </button>
</app-section>

<!-- MARK: Chart -->
<app-section sectionTitle="AFM users' profit per hour">
  <div style="width: 100%; height: 250px; text-align: center">
    <app-chart [data]="flipperStateService.chartData()" title="" timeUnit="hour"></app-chart>
  </div>
</app-section>

<!-- MARK: Flip Status -->
<app-section sectionTitle="Current Flips Status (Public Data Only)">
  <div style="display: flex; flex-wrap: wrap; min-height: 220px">
    @for (server of flipperStateService.flipStatus(); track $index) {
      <!-- MARK: Server Card -->
      <div
        class="mat-elevation-z8"
        [ngStyle]="{
          width: '220px',
          border: '3px solid ' + getServerBorderColor(server.server),
          borderRadius: '4px',
          backgroundColor: getServerBgColor(server.server),
          color: getServerTextColor(server.server),
          textAlign: 'center',
          margin: '5px 15px 5px 0px',
          display: 'flex',
          flexDirection: 'column',
        }"
      >
        <!-- MARK: Server Name -->
        <div style="font-weight: bold; margin: 10px 0px 5px 0px">
          {{ getServerName(server.server) }}
        </div>
        <!-- MARK: Instant -->
        <div style="font-weight: bold; margin: 5px 0px">Current Server Status</div>
        <!-- MARK: Order count -->
        <div style="display: flex; flex-direction: row">
          <!-- Buy order count -->
          <div
            [ngStyle]="{
              width: '50%',
              borderRight: '3px solid ' + getServerBorderColor(server.server),
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'help',
            }"
            matTooltip="Buy Orders Evaluated"
          >
            <!-- Buy order count icon -->
            <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 50%">
              <mat-icon style="align-self: center; font-size: medium">shopping_cart</mat-icon>
            </div>
            <!-- Buy order count number -->
            <div style="display: flex; align-items: center; width: 50%">
              <span>{{ server.totalBuyOrders | smallNumber: false }}</span>
            </div>
          </div>
          <!-- Sell order count -->
          <div
            [ngStyle]="{
              width: '50%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'help',
            }"
            matTooltip="Sell Orders Evaluated"
          >
            <!-- Sell order count icon -->
            <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 50%">
              <mat-icon style="align-self: center; font-size: medium">sell</mat-icon>
            </div>
            <!-- Sell order count number -->
            <div style="display: flex; align-items: center; width: 50%">
              <span>{{ server.totalSellOrders | smallNumber: false }}</span>
            </div>
          </div>
        </div>

        <!-- MARK: Flips count -->
        <div style="display: flex; flex-direction: row">
          <!-- Unused flip count -->
          <div
            [ngStyle]="{
              width: '50%',
              borderRight: '3px solid ' + getServerBorderColor(server.server),
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'help',
            }"
            matTooltip="Unused Unique Flips"
          >
            <!--  Unused flip count icon -->
            <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 50%">
              <mat-icon style="align-self: center; font-size: medium">event_available</mat-icon>
            </div>
            <!--  Unused flip count number -->
            <div style="display: flex; align-items: center; width: 50%">
              <span>{{ server.totalFlips - server.totalFlipsConsumed | smallNumber: false }}</span>
            </div>
          </div>
          <!-- Used flip count -->
          <div
            [ngStyle]="{
              width: '50%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'help',
            }"
            matTooltip="Consumed Unique Flips"
          >
            <!-- Used flip count icon -->
            <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 50%">
              <mat-icon style="align-self: center; font-size: medium">lunch_dining</mat-icon>
            </div>
            <!-- Used flip count number -->
            <div style="display: flex; align-items: center; width: 50%">
              <span>{{ server.totalFlipsConsumed | smallNumber: false }}</span>
            </div>
          </div>
        </div>

        <!-- MARK: Total Profit -->
        <div style="display: flex; flex-direction: row">
          <!-- Total Profit value -->
          <div
            [ngStyle]="{
              width: '50%',
              borderRight: '3px solid ' + getServerBorderColor(server.server),
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '5px 0px',
              cursor: 'help',
              fontWeight: 'bold',
            }"
            matTooltip="Total Profit of unique unused Flips"
          >
            <!--  Total Profit value icon -->
            <div style="display: flex; align-items: center; justify-content: center; height: 100%">
              <mat-icon style="align-self: center; font-size: medium">attach_money</mat-icon>
            </div>
            <!--  Total Profit value number -->
            <div style="display: flex; align-items: center">
              <span>{{ server.totalPremiumProfit - server.totalPremiumProfitConsumed | smallNumber: false }}</span>
            </div>
          </div>
          <!-- Total Consumed Profit value -->
          <div
            [ngStyle]="{
              width: '50%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '5px 0px',
              cursor: 'help',
              fontWeight: 'bold',
            }"
            matTooltip="Total Profit of unique consumed Flips"
          >
            <!--  Total Profit value icon -->
            <div style="display: flex; align-items: center; justify-content: center; height: 100%">
              <mat-icon style="align-self: center; font-size: medium">attach_money</mat-icon>
            </div>
            <!--  Total Profit value number -->
            <div style="display: flex; align-items: center">
              <span>{{ server.totalPremiumProfitConsumed | smallNumber: false }}</span>
            </div>
          </div>
        </div>

        <!-- MARK: Last Hour -->
        <div style="font-weight: bold; margin: 5px 0px">Last Hour Usage</div>

        <!-- MARK: Locations -->
        <div style="display: flex; flex-direction: column; width: 100%; font-size: 12px">
          @if ((flipperStateService.groupedFlipsLocationStatus()[server.server]?.length ?? 0) > 0) {
            @for (stat of flipperStateService.groupedFlipsLocationStatus()[server.server]; track $index) {
              <div style="display: flex; flex-direction: row">
                <!-- City Name -->
                <div
                  [ngStyle]="{
                    display: 'flex',
                    width: '45%',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '5px 0px',
                    cursor: 'help',
                    fontWeight: 'bold',
                  }"
                  matTooltip="Last Hour Stats"
                >
                  <div style="display: flex; align-items: center">
                    <span>{{ stat.buyLocation.displayName }}</span>
                  </div>
                </div>
                <!-- Count -->
                <div
                  [ngStyle]="{
                    display: 'flex',
                    width: '25%',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    margin: '5px 0px',
                    cursor: 'help',
                  }"
                  matTooltip="Consumed flips in the last hour"
                >
                  <div style="display: flex; align-items: center; justify-content: center; height: 100%">
                    <mat-icon style="align-self: center; font-size: medium">lunch_dining</mat-icon>
                  </div>
                  <div style="display: flex; align-items: center">
                    <span>{{ stat.count | smallNumber: false }}</span>
                  </div>
                </div>
                <!-- Profit -->
                <div
                  [ngStyle]="{
                    display: 'flex',
                    width: '30%',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    margin: '5px 0px',
                    cursor: 'help',
                  }"
                  matTooltip="Flips profit in the last hour"
                >
                  <!--  Total Profit value icon -->
                  <div style="display: flex; align-items: center; justify-content: center; height: 100%">
                    <mat-icon style="align-self: center; font-size: medium">attach_money</mat-icon>
                  </div>
                  <!--  Total Profit value number -->
                  <div style="display: flex; align-items: center">
                    <span>{{ stat.profitPremium | smallNumber: false }}</span>
                  </div>
                </div>
              </div>
            }
          } @else {
            <!-- No flips -->
            <div
              [ngStyle]="{
                display: 'flex',
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '5px 0px',
              }"
            >
              <div style="display: flex; align-items: center">
                <span>No flips</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</app-section>

<!-- MARK: Top Flips -->
<app-section sectionTitle="All Time Stats">
  @for (history of flipperStateService.flipHistoryStats(); track $index) {
    <div class="server-history mat-elevation-z4">
      <div class="server-header" [style.border-color]="'var(--' + getServerName(history.server).toLowerCase() + '-color)'">
        <h3 class="server-name">{{ getServerName(history.server) }}</h3>
        <div class="stats-summary">
          <div class="stats-item">
            <mat-icon>lunch_dining</mat-icon>
            <span
              ><strong>{{ history.flipCount | number: '1.0-0' }}</strong> flips consumed</span
            >
          </div>
          <div class="stats-item">
            <mat-icon>attach_money</mat-icon>
            <span
              ><strong>{{ history.totalProfitPremium | smallNumber }}</strong> silver profit</span
            >
          </div>
        </div>
      </div>

      <p class="top-flips-header">Top Flips:</p>
      <div class="flips-grid">
        @for (flip of history.topFlips; track flip.id) {
          <div class="flip-card mat-elevation-z2">
            <div class="flip-card-header">
              <span class="flip-date">{{ flip.flipTime | date: 'mediumDate' : 'UTC' }}</span>
              <span class="flip-profit">{{ flip.profitPremium | smallNumber }} silver</span>
            </div>
            <div class="flip-card-content">
              <div class="item-name">{{ flip.soldItem?.localizedName }}</div>
              <div class="flip-route">
                <div class="location">
                  <span>{{ flip.buyLocation.displayName }}</span>
                </div>
                <mat-icon class="route-arrow">arrow_forward</mat-icon>
                <div class="location">
                  <span>{{ flip.sellLocation.displayName }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</app-section>
